// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import language JSON files
import translationEN from './locales/en.json';
import translationES from './locales/fr.json';
import translationGU from './locales/gu.json';
import translationHI from './locales/hi.json';
import localDataStorage from './store/localDataStorage';

const resources = {
    en: { translation: translationEN },
    es: { translation: translationES },
    gu: { translation: translationGU },
    hi: { translation: translationHI },
};

const savedLanguage = localDataStorage.getLocalStorage('language') || 'en'; // Default to 'en' if not set

i18n.use(initReactI18next).init({
    resources,
    lng: savedLanguage, // Default language
    fallbackLng: 'en', // Fallback language if translation is missing
    interpolation: {
        escapeValue: false, // React already escapes strings
    },
});

export default i18n;
